import { render } from "./BackofficeLayout.vue?vue&type=template&id=759db751"
import script from "./BackofficeLayout.vue?vue&type=script&lang=js"
export * from "./BackofficeLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/layouts/BackofficeLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "759db751"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('759db751', __exports__)) {
    api.reload('759db751', __exports__)
  }
  
  module.hot.accept("./BackofficeLayout.vue?vue&type=template&id=759db751", () => {
    api.rerender('759db751', render)
  })

}


export default __exports__